// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2oG7R","name":"ConsentHeader_name__CMG7S","birthday":"ConsentHeader_birthday__4ksIO","skeleton":"ConsentHeader_skeleton__10KSz"};